import { createAsyncThunk } from "@reduxjs/toolkit";
import { getRequest } from "shared/utils/fetch-api";

export const fetchStepOne = createAsyncThunk(
    'contract/fetchStepOne',
    async ({
        productId,
        insuredCount,
        city,
        promocode,
        programId,
        projectId,
        sellerId
    }: {
        productId: string;
        insuredCount: number;
        city: string;
        programId: string;
        promocode: string;
        projectId: string;
        sellerId: string;
    }, { rejectWithValue }) => {
        const requestBody = {
            userId: "",
            productId: productId,
            insuredCount: insuredCount,
            regionId: city,
            programId: programId,
            promocode: promocode,
            projectId: projectId,
            sellerId: sellerId
        };
        try {
            const response = await getRequest(requestBody, 'max-bot', 'getCalc', 'POST');
            const data = await response.json();
            if (data.Errors.length === 0) {
                return {
                    uid: data.Data.uid, price: data.Data.price, sum: data.Data.sum
                };
            } else {
                return data.Errors;
            }
        } catch (error: any) {
            return error.message;
        }
    }
);

export const fetchDictionaries = createAsyncThunk(
    'contract/fetchDictionaries',
    async ({
        SellerId,
        Id
    }: {
        SellerId: string;
        Id: string
    }, { rejectWithValue }) => {
        let requestBody = {}

        if (SellerId && !Id) {
            requestBody = { "sellerId": SellerId }
        } else if (Id && !SellerId) {
            requestBody = { "Id": Id }
        } else if (SellerId && Id) {
            requestBody = { "sellerId": SellerId }
        }
        try {
            const response = await getRequest(requestBody, 'max-bot', 'getDictionaries', 'POST');
            const data = await response.json();
            if (data.Errors.length === 0) {
                return {
                    Regions: data.Data.regions,
                    Programs: data.Data.programs
                };
            } else {
                return data.Errors;
            }
        } catch (error: any) {
            return error.message;
        }
    }
);

export const fetchPrograms = createAsyncThunk(
    'contract/fetchPrograms',
    async ({
        regionId,
        id
    }: {
        regionId: string;
        id: string
    }, { rejectWithValue }) => {
        const requestBody = {
            id: id,
            regionId: regionId
        }
        try {
            const response = await getRequest(requestBody, 'max-bot', 'getPrograms', 'POST');
            const data = await response.json();
            if (data.Errors.length === 0) {
                return {
                    Programs: data.Data.programs
                };
            } else {
                return data.Errors;
            }
        } catch (error: any) {
            return error.message;
        }
    }
);

export const fetchDefaultId = createAsyncThunk(
    'contract/fetchDefaultId',
    async (_, { rejectWithValue }) => {
        try {
            const response = await getRequest({source: "Site"}, 'max-bot', 'getDefaultId', 'POST');
            const data = await response.json();
            if (data.Errors.length === 0) {
                return {
                    DefaultId: data.Data.DefaultId
                };
            } else {
                return data.Errors;
            }
        } catch (error: any) {
            return error.message;
        }
    }
);